export const url_CarregarDados_ID = '/clinica/carregar/:idclinica';
export const url_CarregarDados_Empresa = '/empresa/listar';

